<script setup lang="ts">
import { EntityNewsCard, type TNewsCard } from '~/components/entity/news'

import { WidgetSidebarNews } from '~/components/widget/sidebar-news'
import type { IResponseData } from '~/types'

import 'swiper/css'
import '~/components/entity/news/style.css'
import { WidgetSidebarArticles } from '~/components/widget/sidebar-articles'

const { data: featuredNews } = useApi<IResponseData<TNewsCard[]>>(
  () => useUrlWithParams('/news/featured'),
  {
    key: 'home-page.featured-news'
  }
)
</script>

<template>
  <div class="flex flex-col gap-5 md:grid md:grid-cols-1 xl:grid-cols-4">
    <template v-if="featuredNews">
      <div
        class="grid grid-cols-2 content-start gap-3.5 md:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:col-span-3 xl:grid-cols-3"
      >
        <EntityNewsCard v-for="card in featuredNews.data" :key="card.id" v-bind="card" />
      </div>
    </template>
    <aside class="space-y-5">
      <WidgetSidebarNews
        :heading="$t('widget.home_page.news.latest')"
        path="/news"
        variant="white"
      />
      <WidgetSidebarArticles
        :heading="$t('widget.home_page.news.useful')"
        path="/news"
        :query-params="{
          per_page: '5',
          'filter[position]': 'mainpage',
          'filter[type]': 'article'
        }"
        variant="white"
      />
    </aside>
  </div>
</template>
